import { ComponentClass } from 'react';
export { ComponentClass };

import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';
import { NotificationPaneProps } from './components/NotificationPane';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "InAppNotifications", webpackPrefetch: true */ './lazyIndex')
);

export const NotificationPane = createLazyComponent(lazyModule, m => m.NotificationPane);

export {
    NewMailNotificationFilter,
    registerNewMailNotificationFilter,
} from './utils/newMailNotificationFilter';
export { default as areRemindersVisible } from './selectors/areRemindersVisible';
export { default as getActiveReminderCount } from './selectors/getActiveReminderCount';
export { default as onLikeNotificationClicked } from './actions/onLikeNotificationClicked';
export { default as onNewMailNotificationClicked } from './actions/onNewMailNotificationClicked';
export { default as onReminderClicked } from './actions/onReminderClicked';
export { default as toggleReminderVisibility } from './mutators/toggleReminderVisibility';
export { default as LikeNotificationData } from './store/schema/LikeNotificationData';
export { NotificationPaneProps };

export let lazyOnDismissAutomaticReplyNotification = new LazyImport(
    lazyModule,
    m => m.onDismissAutomaticReplyNotification
);
